class SitecoreFields {
    vinRegistrationExistsAPI = {
        type: String,
        required: true,
    };
    generatePDFAPI = {
        type: String,
        required: true,
    };
    validateBulkUploadAPI = {
        type: String,
        required: true,
    };
    vinNumberText = {
        type: String,
        required: true,
    };
    vinNumberHelpText = {
        type: String,
        required: true,
    };
    registrationNumberText = {
        type: String,
        required: true, 
    };
    registrationNumberHelpText = {
        type: String,
        required: true,
    };
    generateCertificateButtonText = {
        type: String,
        required: true,
    };
    successfulGenerationMessage = {
        type: String,
        required: true,
    };
    errorGenerationMessage = {
        type: String,
        required: true,
    };
    waitingGenerationMessage = {
        type: String,
        required: true,
    };
    downloadsSectionTitle = {
        type: String,
        required: true,
    };
    licensePlateText = {
        type: String,
        required: true,
    };
    downloadAllFilesLinkText = {
        type: String,
        required: true,
    };
    downloadFileLinkText = {
        type: String,
        required: true,
    };
    singleCertificateTabText = {
        type: String,
        required: true,
    };
    bulkCertificateTabText = {
        type: String,
        required: true,
    };
    bulkGenerateCertificatesButtonText = {
        type: String,
        required: true,
    };
    bulkVehicleDataText = {
        type: String,
        required: true,
    };
    bulkVehicleDataHelpText = {
        type: String,
        required: true,
    };
    bulkErrorGenerationMessage = {
        type: String,
        required: true,
    };
    generateBulkPDFAPI = {
        type: String,
        required: true,
    };
    bulkDownloadFileLinkText = {
        type: String,
        required: true,
    };
    vehicleDataInvalidFormatError = {
        type: String,
        required: true,
    };
    vehicleDataInvalidVinLengthError = {
        type: String,
        required: true,
    };
    vehicleDataInvalidVinFormatError = {
        type: String,
        required: true,
    };
    vehicleDataInvalidRegistrationLengthError = {
        type: String,
        required: true,
    };
    vehicleDataInvalidRegistrationFormatError = {
        type: String,
        required: true,
    };
}

export default SitecoreFields;
